import { formatMoney, priceFor } from '@repo/contracts/services-pricing';

import { PriceCalculator } from '../price-calculator';
import { Container, SectionHeading } from '../ui';

export function Pricing() {
  return (
    <section
      aria-labelledby="pricing-title"
      className="bg-surface py-24 md:py-32"
      id="pricing"
    >
      <Container>
        <SectionHeading
          eyebrow="Pricing"
          id="pricing-title"
          intro="One flat rate for every page. Nothing to pay until scope is agreed."
          title={`${formatMoney(priceFor(1).ratePerPage)} a page. That’s it.`}
        />
        <div className="mt-12">
          <PriceCalculator />
        </div>
      </Container>
    </section>
  );
}
